import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`Since beginning I have enjoyed work of building web applications.I am an expert on the ground of web development and can do many things related to the job.
I am quite adept in coding and front end frameworks, libraries and in creating applications using client server model including Angular,React.js,HTML/CSSJavaScript,Typescript`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      